import React, { lazy, Component } from 'react';
import { FadeIn } from './ui/FadeIn';
import { SectionHeading } from './ui/SectionHeading';
import { MapPin, Clock, Phone } from 'lucide-react';
import { Button } from './ui/Button';
export function LocationMap() {
  const address = 'Avenida Cabildo 1370, Buenos Aires, Argentina';
  const mapEmbedSrc = `https://www.google.com/maps?q=${encodeURIComponent(address)}&output=embed`;
  const directionsHref = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(address)}`;
  return <section id="ubicacion" className="py-24 md:py-32 bg-background" data-id="element-150">
      <div className="container mx-auto px-6 md:px-12" data-id="element-151">
        <SectionHeading title="Visítanos en nuestra clínica" subtitle="Te esperamos en el corazón de Buenos Aires para iniciar tu valoración personalizada." data-id="element-152" />

        <FadeIn delay={0.1} data-id="element-153">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-stretch mt-16" data-id="element-154">
            {/* Map */}
            <div className="lg:col-span-2 rounded-2xl overflow-hidden shadow-lg border border-border min-h-[360px] lg:min-h-[480px]" data-id="element-155">
              <iframe title="Mapa de ubicación de Libelle Estética" src={mapEmbedSrc} className="w-full h-full min-h-[360px] lg:min-h-[480px]" style={{
              border: 0
            }} loading="lazy" referrerPolicy="no-referrer-when-downgrade" allowFullScreen data-id="element-156" />
            </div>

            {/* Details */}
            <div className="bg-surface rounded-2xl border border-border shadow-sm p-8 md:p-10 flex flex-col" data-id="element-157">
              <h3 className="font-serif text-3xl text-foreground mb-8" data-id="element-158">
                Libelle Estética
              </h3>

              <ul className="space-y-7 flex-1" data-id="element-159">
                <li className="flex items-start gap-4" data-id="element-160">
                  <div className="w-11 h-11 rounded-full bg-champagne flex items-center justify-center text-gold flex-shrink-0" data-id="element-161">
                    <MapPin className="w-5 h-5" data-id="element-162" />
                  </div>
                  <div data-id="element-163">
                    <p className="text-xs uppercase tracking-widest text-gold mb-1" data-id="element-164">
                      Dirección
                    </p>
                    <p className="text-foreground font-light leading-relaxed" data-id="element-165">
                      Avenida Cabildo 1370
                      <br data-id="element-166" />
                      Buenos Aires, Argentina
                    </p>
                  </div>
                </li>

                <li className="flex items-start gap-4" data-id="element-167">
                  <div className="w-11 h-11 rounded-full bg-champagne flex items-center justify-center text-gold flex-shrink-0" data-id="element-168">
                    <Clock className="w-5 h-5" data-id="element-169" />
                  </div>
                  <div data-id="element-170">
                    <p className="text-xs uppercase tracking-widest text-gold mb-1" data-id="element-171">
                      Horario
                    </p>
                    <p className="text-foreground font-light leading-relaxed" data-id="element-172">
                      Lun a Vie: 10:00 — 20:00
                      <br data-id="element-173" />
                      Sáb: 10:00 — 14:00
                    </p>
                  </div>
                </li>

                <li className="flex items-start gap-4" data-id="element-174">
                  <div className="w-11 h-11 rounded-full bg-champagne flex items-center justify-center text-gold flex-shrink-0" data-id="element-175">
                    <Phone className="w-5 h-5" data-id="element-176" />
                  </div>
                  <div data-id="element-177">
                    <p className="text-xs uppercase tracking-widest text-gold mb-1" data-id="element-178">
                      Teléfono
                    </p>
                    <p className="text-foreground font-light leading-relaxed" data-id="element-179">
                      +54 11 4000 0000
                    </p>
                  </div>
                </li>
              </ul>

              <a href={directionsHref} target="_blank" rel="noopener noreferrer" className="mt-10" data-id="element-180">
                <Button variant="outline" className="w-full" data-id="element-181">
                  Cómo llegar
                </Button>
              </a>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}